import { createClient } from '@supabase/supabase-js';

/**
 * Supabase Client Configuration
 * Initializes the Supabase client for authentication and database operations
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Debug: Log environment variable status (only in development)
if (import.meta.env.DEV) {
  console.log('🔍 Environment Check:');
  console.log('  VITE_SUPABASE_URL:', supabaseUrl ? '✅ Set' : '❌ Missing');
  console.log('  VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Set' : '❌ Missing');
  console.log('  All env vars:', Object.keys(import.meta.env).filter(k => k.startsWith('VITE_')));
}

// Check if Supabase is configured
export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn(
    '⚠️  Supabase credentials are missing. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.\n' +
    'The app will run in limited mode without authentication features.\n' +
    '📝 Make sure:\n' +
    '   1. Your .env file is in the root directory\n' +
    '   2. Variables are prefixed with VITE_\n' +
    '   3. You have restarted the dev server after creating/updating .env\n' +
    '   4. No quotes around the values in .env'
  );
}

// Create Supabase client with fallback values to prevent errors
// Use placeholder values if not configured - these won't work but won't crash the app
const clientUrl = supabaseUrl || 'https://placeholder.supabase.co';
const clientKey = supabaseAnonKey || 'placeholder-key';

// Create Supabase client with optimized settings
export const supabase = createClient(clientUrl, clientKey, {
  auth: {
    autoRefreshToken: isSupabaseConfigured,
    persistSession: isSupabaseConfigured,
    detectSessionInUrl: isSupabaseConfigured,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': 'lc-performance-web',
    },
  },
  // Add realtime configuration
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export default supabase;
